export enum ESubclinicalType {
  ImageAnalysis = 2,
  MedicalTest = 5
}
